const quickWords = ["带货翻车", "数据注水", "饭圈应援", "合同纠纷", "虚假宣传", "搬运二创"];

export default function Hero() {
  return (
    <section className="relative overflow-hidden">
      <div className="pointer-events-none absolute inset-0 -z-10 bg-gradient-to-b from-background-100 to-background-50" />
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-2 lg:gap-14">
        {/* 左文 */}
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-3 py-1.5 text-xs font-semibold text-primary-700">
            <i className="ri-flashlight-fill text-sm text-primary-500"></i>
            站内搜索 · 专题检索 · 内容查询
          </div>
          <h1 className="mt-5 font-heading text-4xl font-black leading-tight tracking-tight text-foreground-950 md:text-[3.4rem] md:leading-[1.08]">
            <span className="text-primary-600">网黑料</span>，
            <br className="hidden sm:block" />
            一个关键词，直达目标
            <span className="text-primary-600">专题</span>
          </h1>
          <p className="mt-5 text-[15px] leading-7 text-foreground-600 md:text-base">
            想查找某类黑料却不知道从何入手？把你要查的「关键词」放进搜索框，
            网黑料会带你找到对应的<strong className="font-semibold text-foreground-900">专题合集</strong>与
            <strong className="font-semibold text-foreground-900">内容查询结果</strong>。
            从热点事件到行业乱象，持续归档、按主题聚合，检索更省力。
          </p>
          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#topics"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-archive-drawer-line text-base"></i>
              浏览精选专题
            </a>
            <a
              href="#query"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-7 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-grid-line text-base"></i>
              进入内容查询
            </a>
          </div>
          <div className="mt-7 flex flex-wrap items-center gap-2">
            <span className="mr-1 text-xs text-foreground-400">热门查找词</span>
            {quickWords.map((w) => (
              <a
                key={w}
                href="#hot"
                className="rounded-full bg-background-100 px-3 py-1 text-xs text-foreground-600 transition-colors hover:bg-secondary-100 hover:text-secondary-900 whitespace-nowrap"
              >
                #{w}
              </a>
            ))}
          </div>
        </div>

        {/* 右图：双封面拼贴 */}
        <div className="grid grid-cols-5 grid-rows-6 gap-3 md:gap-4">
          <div className="group relative col-span-3 row-span-6 overflow-hidden rounded-xl">
            <img
              src="https://readdy.ai/api/search-image?query=editorial%20investigation%20desk%20with%20stacked%20case%20files%2C%20red%20evidence%20tapes%20and%20a%20large%20magnifying%20glass%20over%20printed%20articles%2C%20dramatic%20moody%20side%20light%2C%20deep%20crimson%20and%20ink%20tones%2C%20documentary%20photojournalism%20style%2C%20rich%20texture&width=900&height=1200&seq=hero-main-cover&orientation=portrait"
              alt="网黑料检索专题封面"
              className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-5">
              <span className="inline-flex items-center gap-1 rounded bg-primary-500 px-2 py-0.5 text-[11px] font-semibold text-background-50">
                <i className="ri-fire-fill"></i>今日焦点
              </span>
              <h3 className="mt-2 font-heading text-lg font-bold leading-snug text-background-50">
                检索热度 TOP 专题合集导览
              </h3>
              <p className="mt-1 text-xs text-background-200/90">关键词聚合 · 按题材分层归档</p>
            </div>
          </div>

          <div className="relative col-span-2 row-span-3 overflow-hidden rounded-xl">
            <img
              src="https://readdy.ai/api/search-image?query=abstract%20red%20magnifier%20focusing%20on%20dense%20text%20columns%20and%20keyword%20highlights%2C%20editorial%20search%20concept%2C%20warm%20paper%20and%20crimson%20palette%2C%20clean%20minimal%20flat%20graphic&width=600&height=600&seq=hero-small-top&orientation=squarish"
              alt="网黑料关键词查找"
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
            <span className="absolute bottom-3 left-3 font-heading text-xs font-bold text-background-50">关键词查找</span>
          </div>

          <div className="relative col-span-2 row-span-3 overflow-hidden rounded-xl">
            <img
              src="https://readdy.ai/api/search-image?query=clustered%20topic%20covers%20arranged%20in%20a%20grid%20with%20red%20chapter%20markers%20and%20file%20labels%2C%20editorial%20collection%20index%20concept%2C%20ink%20and%20amber%20tones%20on%20warm%20paper%2C%20minimal%20flat%20design&width=600&height=600&seq=hero-small-bottom&orientation=squarish"
              alt="网黑料专题合集索引"
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
            <span className="absolute bottom-3 left-3 font-heading text-xs font-bold text-background-50">专题合集索引</span>
          </div>
        </div>
      </div>
    </section>
  );
}